import fileApi from "../api/file";

export default {
    methods: {
        uploadFile(file) {
            return new Promise((resolve) => {
                let formData = new FormData();
                formData.append('upfile', file);

                fileApi.uploadFile(formData)
                    .then((response) => {
                        resolve(response.data.id)
                    })
                    .catch(error => {
                        this.$snotify.error(error)

                        resolve(null)
                    });
            })
        }
    }
}